import React, { useEffect, useRef } from "react";
import {
  FormGroup,
  Label,
  Input,
  Button,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import PopoverItem from "../common/PRpopover";

export default function HomeAttach(props) {
  const fileInput = useRef(null);
  useEffect(() => {
    //console.log(props);
  }, []);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <div>
      <FormGroup tag="fieldset">
        <Label className={props.fstate.image.fontWeight ? "label-font" : ""}>
          {props.translate(props.lang, props.fstate.image.label)}{" "}
          {!props.fstate.image.required ? (
            <span className="colorred">
              {props.translate(props.lang, "optionalSign")}
            </span>
          ) : (
            <></>
          )}
        </Label>
        <PopoverItem
          elem={props.fstate.image}
          translate={props.translate}
          lang={props.lang}
        />
        {/* <div className="flex">
          <div className="flex-element">
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="radio1"
                  id="optionY"
                  checked={props.imageOption === "Y"}
                  onClick={(e) => {
                    props.validate(e);
                  }}
                  onChange={(e) => {
                    props.onChangeImageOption(e);
                  }}
                />{" "}
                {props.translate(props.lang, "Yes")}
              </Label>
            </FormGroup>
          </div>
          <div className="flex-element">
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="radio1"
                  id="optionN"
                  checked={props.imageOption === "N"}
                  onChange={(e) => {
                    props.onChangeImageOption(e);
                  }}
                />{" "}
                {props.translate(props.lang, "No")}
              </Label>
            </FormGroup>
          </div>
        </div> */}
      </FormGroup>

      {/* {props.imageOption === "Y" ? ( */}
      <FormGroup>
        <div className="file-input-wrapper">
          <div
            className="d-flex justify-content-around"
            onDrop={(e) => handleDrop(e)}
            onDragOver={(e) => handleDragOver(e)}
            onDragEnter={(e) => handleDragEnter(e)}
            onDragLeave={(e) => handleDragLeave(e)}
          >
                      <div className="d-flex dragdrop containerFlex">
                          <p className="itemFlex"> {props.translate(props.lang, "DragFiles")}</p>
                          <div className="btnAddImage itemFlex">
                <Button
                  color="info"
                  id="AddImage"
                  onClick={(e) => handleClick(e)}
                >
                                  {props.translate(props.lang, "AddAttchmentLabel")}
                </Button>
              </div>
            </div>
          </div>
          <Input
            ref={fileInput}
            type="file"
            name="image"
            id="imageInput"
            value=""
            onChange={(e) => {
              props.attach(e);
            }}
          />
        </div>
      </FormGroup>
      {/* ) : (
        ""
      )} */}

      {props.imageList
        ? props.imageList.map((a) => (
            <FormGroup key={a.guid}>
              <InputGroup>
                <Input placeholder={a.filename} />
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    onClick={(e) => {
                      props.deleteAttach(e, a.guid);
                    }}
                  >
                            {props.translate(props.lang, "Delete")}
                  </InputGroupText>
                </InputGroupAddon>
                <InputGroupAddon addonType="append">
                  <InputGroupText
                    onClick={(e) => {
                      props.previewAttach(e, a.guid);
                    }}
                  >
                            {a.preview ? props.translate(props.lang, "Preview") + "..." : props.translate(props.lang, "Close") + "..."}
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
          ))
        : ""}

      {props.prevFile ? (
        <FormGroup>
          <img id="preview" alt="" src={props.prevFile}></img>
        </FormGroup>
      ) : (
        ""
      )}
    </div>
  );
}
